import emailObfuscator from './lib/emailObfuscator'
import GHeader from './component/GHeader'
import copyPictureForLargerScreen from './lib/copyPictureForLargerScreen'
import directAgents from './lib/directAgents';

// console.log(window.btoa(unescape(encodeURIComponent('info@acorn-vet.com'))))
emailObfuscator({
	b64: 'aW5mb0BhY29ybi12ZXQuY29t',
	selector: '.mailto'
})

new GHeader()

copyPictureForLargerScreen()
directAgents()
